$ = require('jquery');

$(() => {

    let headerMenu = $('.header-menu');
    headerMenu.hide();

    let headerBurger = $('.header-burger');
    headerBurger.on('click', () => {
        document.body.classList.toggle('header-burger-open');
        if (headerBurger.hasClass('open')) {
            $('html').removeClass('no-admin-bar');
            headerBurger.removeClass('open');
            headerBurger.css('pointer-events', 'none');
            setTimeout(() => {
                if (!(headerBurger.hasClass('open'))) {
                    headerMenu.hide();
                    headerBurger.css('pointer-events', 'auto');
                }
            }, 500)
        } else {
            $('html').addClass('no-admin-bar');
            headerMenu.show();
            headerBurger.css('pointer-events', 'none');
            setTimeout(() => {
                headerBurger.css('pointer-events', 'auto');
            }, 500)
            headerBurger.addClass('open');
        }
    });
    
});